export default __webpack_public_path__ + "static/media/home-about-ape.159bc7a6.svg";